import React from "react";
import { Container, Row, Col, Card } from "react-bootstrap";
import "./Services.css";

// Dynamischer Import aller Bilder aus assets/services
const importAll = (r) => r.keys().map(r);
const serviceImages = importAll(require.context("../assets/services", false, /\.(png|jpe?g|webp)$/));

// Service-Daten basierend auf dachrein.com
const services = [
  { title: "Dachreinigung", description: "Schonende Reinigung von Dächern zur Werterhaltung Ihres Hauses." },
  { title: "Fassadenreinigung", description: "Gründliche Fassadenreinigung zur Entfernung von Schmutz, Moos und Algen." },
  { title: "Einfahrtsreinigung", description: "Professionelle Reinigung von Einfahrten für ein gepflegtes Erscheinungsbild." },
  { title: "Gehwegreinigung", description: "Saubere Gehwege durch gründliche Hochdruckreinigung." },
  { title: "Mauerreinigung", description: "Reinigung von Mauern zur Entfernung von Ablagerungen und Verfärbungen." },
  { title: "Terrassenreinigung", description: "Reinigung von Terrassen und Gehwegen für eine gepflegte Optik." },
  { title: "Malerarbeiten", description: "Fachgerechte Malerarbeiten zur Verschönerung Ihrer Immobilie." },
  { title: "Sanierungsarbeiten", description: "Professionelle Sanierungsarbeiten zur Werterhaltung Ihrer Gebäude." },
  { title: "Harzverfugung", description: "Langlebige Harzverfugung für gepflasterte Flächen." },
];

// Bilder dynamisch zuweisen
services.forEach((service, index) => {
  service.image = serviceImages[index] || "https://dummyimage.com/300x200/ccc/fff&text=Kein+Bild";
});

const Services = () => {
  return (
    <Container className="services-section">
      <h2 className="text-center">Unsere Leistungen</h2>
      <p className="text-center">Wir bieten professionelle Reinigungslösungen für verschiedene Oberflächen.</p>
      
      <Row>
        {services.map((service, index) => (
          <Col md={4} sm={6} xs={12} key={index} className="mb-4">
            <Card className="service-card">
              <Card.Img variant="top" src={service.image} alt={service.title} />
              <Card.Body>
                <Card.Title>{service.title}</Card.Title>
                <Card.Text>{service.description}</Card.Text>
              </Card.Body>
            </Card>
          </Col>
        ))}
      </Row>
    </Container>
  );
};

export default Services;
